import { z } from 'zod';

export const PlatformSchema = z.enum(['fb', 'ig']);
export type Platform = z.infer<typeof PlatformSchema>;

export const PostContentSchema = z.object({
  id: z.string().guid(),
  postId: z.string().guid(),
  platform: PlatformSchema,
  body: z.string(),
  hashtags: z.array(z.string()),
  sourceUrl: z.string().nullable(),
  /** Extra link under the text (pl. videó), per platform. */
  attachmentUrl: z.string().nullable(),
  version: z.number().int(),
  isCurrent: z.boolean(),
  generatedBy: z.enum(['ai', 'manual', 'ai_edited']),
  aiTaskId: z.string().guid().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type PostContent = z.infer<typeof PostContentSchema>;

export const UpsertPostContentSchema = z.object({
  platform: PlatformSchema,
  body: z.string().min(1).max(8000),
  hashtags: z.array(z.string().min(1).max(60)).max(50).default([]),
  sourceUrl: z.string().url().max(2048).nullable().optional(),
  attachmentUrl: z.string().url().max(2048).nullable().optional(),
});
export type UpsertPostContent = z.infer<typeof UpsertPostContentSchema>;
